import * as React from 'react'
import * as Styled from './Table.styles'

function addStickyClass(i, sticky) {
  return i === 0 && sticky ? 'sticky' : ''
}

const Table = ({ json, ...props }) => (
  <Styled.TableWrapper className="leshen-table-wrapper">
    <Styled.Table {...props} className="leshen-table">
      <thead>
        <tr>
          {json?.headings?.length > 0 &&
            json.headings.map((heading, i) => (
              <th key={heading} className={addStickyClass(i, json.sticky)}>
                {heading}
              </th>
            ))}
        </tr>
      </thead>
      <tbody>
        {json?.rows?.length > 0 &&
          json.rows.map((row) => (
            <tr key={row}>
              {row.map((item, i) => (
                <td
                  key={item}
                  htmlFor="table-item"
                  className={addStickyClass(i, json.sticky)}
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              ))}
            </tr>
          ))}
      </tbody>
    </Styled.Table>
  </Styled.TableWrapper>
)

export default Table
